import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";
import {Helmet} from "react-helmet";

// core components
import { useTranslation } from 'react-i18next';

const lngs = {
  en: { nativeName: 'English' },
  es: { nativeName: 'Spanish' }
};
function SectionBlog() {
const { t } = useTranslation();

  return (
    <>
      <div className="section section-blog cd-section" id="blogs">
      
        <div className="blog-4">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto" md="8">
              <Helmet>
                <h2 className="title text-center">TOURS</h2>
                <meta name="description" content="tours"/>
                </Helmet>
                <h2 className="title text-center">TOURS</h2>

                <br />
              </Col>
            </Row>
            <Row>
            <Col md="6">
                <Card className="card-plain card-blog text-center">
                  <div className="card-image">
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <img
                        alt="..."
                        className="img img-raised"
                        src={require("assets/img/a0.jpg")}
                      />
                    </a>
                  </div>
                  <Helmet>
                  <CardBody>
                    <h6 className="card-category text-danger">CITY TOUR EN CHIVA</h6>
                    {/* <CardTitle tag="h3">
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      INCLUYE:
 Guía Personalizado
 Ingreso a los Sitios Turísticos
 Recogida y Retorno en la Puerta del Hotel (Bocagrande, Laguito, Castillo)
 Salidas Todos los Días de: 9:00 am – 1:00 pm y 2:00 pm – 6:30 pm

                      </a>
                    </CardTitle> */}
                    <p className="card-description">
                    {t('description.part20')}


                    </p>
                    <br />
                    <Button
                      className="btn-round"
                      color="danger"
                      href="/chivatour"
                    >
                    {t('description.part21')}

                    </Button>
                  </CardBody>
                  <meta name="description" content="Zapatos Viejos, Castillo de San Felipe de Barajas, Avenida Santander, Las Famosas Murallas, Las Bóvedas, Centro Histórico"/>

</Helmet>
<CardBody>
                    <h6 className="card-category text-danger">CITY TOUR EN CHIVA</h6>
                    {/* <CardTitle tag="h3">
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      INCLUYE:
 Guía Personalizado
 Ingreso a los Sitios Turísticos
 Recogida y Retorno en la Puerta del Hotel (Bocagrande, Laguito, Castillo)
 Salidas Todos los Días de: 9:00 am – 1:00 pm y 2:00 pm – 6:30 pm

                      </a>
                    </CardTitle> */}
                    <p className="card-description">
                    {t('description.part20')}


                    </p>
                    <br />
                    <Button
                      className="btn-round"
                      color="danger"
                      href="/chivatour"
                    >
                    {t('description.part21')}

                    </Button>
                  </CardBody>

                </Card>
              </Col>
              <Col md="6">
                <Card className="card-plain card-blog text-center">
                  <div className="card-image">
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <img
                        alt="..."
                        className="img img-raised"
                        src={require("assets/img/a1.jpg")}
                      />
                    </a>
                  </div><Helmet>
                  <CardBody>
                    <h6 className="card-category text-info">PLAYA BLANCA</h6>
                    {/* <CardTitle tag="h3">
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      Nuestro increíble Tour Noche Blanca y disfruta de 3 horas de recorrido en la embarcación Bequia Eagle.
                      </a>
                    </CardTitle> */}
                    <p className="card-description">
                    {t('description.part22')}

                    </p>
                    <br />
                    <Button
                      className="btn-round"
                      color="primary"
                      href="/playablanca"
                    >
                    {t('description.part21')}
                    </Button>
                  </CardBody>
                <meta name="description" content="Playa Blanca"/>

                  </Helmet>
                  <CardBody>
                    <h6 className="card-category text-info">PLAYA BLANCA</h6>
                    {/* <CardTitle tag="h3">
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      Nuestro increíble Tour Noche Blanca y disfruta de 3 horas de recorrido en la embarcación Bequia Eagle.
                      </a>
                    </CardTitle> */}
                    <p className="card-description">
                    {t('description.part22')}

                    </p>
                    <br />
                    <Button
                      className="btn-round"
                      color="primary"
                      href="/playablanca"
                    >
                    {t('description.part21')}
                    </Button>
                  </CardBody>
                </Card>
              </Col>
            </Row>
           

            <Row>
              <Col md="6">
                <Card className="card-plain card-blog text-center">
                  <div className="card-image">
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <img
                        alt="..."
                        className="img img-raised"
                        src={require("assets/img/a2.jpg")}
                      />
                    </a>
                  </div>
                  <CardBody>
                    <h6 className="card-category text-danger">CUATRO ISLAS + PLANCTON</h6>
                    {/* <CardTitle tag="h3">
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      Por ser vehículos Tradicionales de Colombia, Las Chivas cuentan con la autorización para entrar a diferentes sitios turísticos de nuestra ciudad; el tour inicia con un recorrido panorámico por los barrios residenciales más sofisticados de nuestra ciudad, posteriormente se visitan sitios turísticos tales como Zapatos Viejos, Castillo de San Felipe de Barajas, un Recorrido por la Avenida Santander donde se podrán apreciar Las Famosas Murallas y diferentes Baluartes del Centro Histórico, Finalizando con el Paradero Turístico denominado Las Bóvedas y una caminata guiada por el Centro Histórico.


                      </a>
                    </CardTitle> */}
                    <p className="card-description">
                    {t('description.part23')}

                   
                    </p>
                    <br />
                    <Button
                      className="btn-round"
                      color="danger"
                      href="/cuatroislas"
                    >
                    {t('description.part21')}
                    </Button>
                  </CardBody>
                </Card>
              </Col>
              <Col md="6">
                <Card className="card-plain card-blog text-center">
                  <div className="card-image">
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <img
                        alt="..."
                        className="img img-raised"
                        src={require("assets/img/a3.jpg")}
                      />
                    </a>
                  </div>
                  <CardBody>
                    <h6 className="card-category text-success">PALMARITO BEACH</h6>
                    {/* <CardTitle tag="h3">
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        Readers Pick of The Month
                      </a>
                    </CardTitle> */}
                    <p className="card-description">

                    {t('description.part24')}



                    </p>
                    <br />
                    <Button
                      className="btn-round"
                      color="success"
                      href="/palmarito"
                    >
                    {t('description.part21')}
                    </Button>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
            <Col md="6">
                <Card className="card-plain card-blog text-center">
                  <div className="card-image">
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <img
                        alt="..."
                        className="img img-raised"
                        src={require("assets/img/a4.jpg")}
                      />
                    </a>
                  </div>
                  <CardBody>
                    <h6 className="card-category text-danger">GENTE DE MAR</h6>
                    {/* <CardTitle tag="h3">
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      INCLUYE:
 Guía Personalizado
 Ingreso a los Sitios Turísticos
 Recogida y Retorno en la Puerta del Hotel (Bocagrande, Laguito, Castillo)
 Salidas Todos los Días de: 9:00 am – 1:00 pm y 2:00 pm – 6:30 pm

                      </a>
                    </CardTitle> */}
                    <p className="card-description">

                    {t('description.part25')}


                    </p>
                    <br />
                    <Button
                      className="btn-round"
                      color="danger"
                      href="/gentedemar"
                    >
                    {t('description.part21')}
                    </Button>
                  </CardBody>
                </Card>
              </Col>
              <Col md="6">
                <Card className="card-plain card-blog text-center">
                  <div className="card-image">
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <img
                        alt="..."
                        className="img img-raised"
                        src={require("assets/img/a5.jpg")}
                      />
                    </a>
                  </div>
                  <CardBody>
                    <h6 className="card-category text-info">TOUR BAHIA</h6>
                    {/* <CardTitle tag="h3">
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      Nuestro increíble Tour Noche Blanca y disfruta de 3 horas de recorrido en la embarcación Bequia Eagle.
                      </a>
                    </CardTitle> */}
                    <p className="card-description">
                    {t('description.part26')}

                    </p>
                    <br />
                    <Button
                      className="btn-round"
                      color="primary"
                      href="/bahia"
                    >
                    {t('description.part21')}
                    </Button>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
       
      </div>
    </>
  );
}

export default SectionBlog;
